import React, { ForwardedRef, forwardRef, useEffect, useState } from 'react';
import { NumberFormatProps } from 'react-number-format';
import { NumberField } from '../numberField';
import { TextFieldProps } from '../textField';

type Props = {
  numberInputProps?: NumberFormatProps;
  shiftDecimals?: number;
  returnInteger?: boolean;
  ref?: ForwardedRef<HTMLInputElement>;
} & TextFieldProps;
export type CurrencyFieldProps = Props;

/**
 * CurrencyField is a NumberField wrapper that sets reasonable defaults for
 * usage as a currency field.
 *
 * It uses EURO as default currency.
 */
export const CurrencyField = forwardRef<HTMLInputElement, Props>(
  (
    {
      shiftDecimals = 0,
      returnInteger = false,
      numberInputProps,
      value,
      label,
      onChange,
      ...textFieldProps
    },
    ref
  ) => {
    const defaultNumberInputProps: NumberFormatProps = {
      fixedDecimalScale: true,
      decimalScale: 2,
      decimalSeparator: ',',
      thousandSeparator: '.'
    };

    const [localValue, setLocalValue] = useState(value);

    const handleValueChange = (event: React.ChangeEvent<HTMLInputElement>) => {
      const newValue = returnInteger
        ? Math.round(Number(event.target.value) * 10 ** shiftDecimals)
        : Number(event.target.value) * 10 ** shiftDecimals;
      setLocalValue(newValue);
      event.target.value = newValue.toString();
      onChange && onChange(event);
    };

    useEffect(() => {
      setLocalValue(value);
    }, [value]);

    return (
      <NumberField
        ref={ref}
        value={Number(localValue) / 10 ** shiftDecimals}
        label={label && label + ' (€)'}
        onChange={handleValueChange}
        {...textFieldProps}
        numberInputProps={{
          ...defaultNumberInputProps,
          ...numberInputProps
        }}
      />
    );
  }
);
